import React from 'react';
import config from '../../../../config';
import NumberFilter from '@inovua/reactdatagrid-community/NumberFilter';
import * as Yup from 'yup';
import DateFilter from '@inovua/reactdatagrid-community/DateFilter';
import Header from '../../../components/Header/Header';
import Toolbar from '../../../components/Toolbar/Toolbar';
import Table from '../../../components/Table/Table';
import NavBar from '../../../components/NavBar/NavBar';
import BoolFilter from '@inovua/reactdatagrid-community/BoolFilter';
import { Switch } from '@mui/material';
import { useTranslation } from 'react-i18next';

const PromoCampaign = () => {
  const urls = {
    list: config.PROMO_CAMPAIGN,
    create: config.PROMO_CAMPAIGN,
    update: config.PROMO_CAMPAIGN_WITH_ID,
    delete: config.PROMO_CAMPAIGN_WITH_ID
  };
  const resource = 'PRODUCT';
  const { t } = useTranslation();

  const columns = [
    {
      header: t('id'),
      name: 'promoCampaignId',
      type: 'number',
      filterEditor: NumberFilter
    },
    {
      header: t('name'),
      name: 'promoCampaignName',
      type: 'string',
      required: true,
      validationSchema: Yup.string().max(255).required('Name is required'),
      isEditable: true,
      defaultFlex: 1
    },
    {
      header: t('description'),
      type: 'string',
      validationSchema: Yup.string().max(255).required('Description is required'),
      isEditable: true,
      name: 'promoCampaignDescription'
    },
    {
      header: t('internal.distributor'),
      name: 'internalDistributor',
      required: true,
      type: 'select',
      isEditable: true,
      options: {
        url: config.INTERNAL_DISTRIBUTOR,
        name: 'name',
        uniqueId: 'internalDistributorId',
        requestField: 'internalDistributorId'
      },
      render: ({ value }) => value && value.name,
      defaultFlex: 1
    },
    {
      header: t('external.distributor'),
      name: 'externalDistributor',
      required: true,
      type: 'select',
      isEditable: true,
      options: {
        url: config.EXTERNAL_DISTRIBUTOR,
        name: 'externalDistributorName',
        uniqueId: 'externalDistributorId',
        requestField: 'externalDistributorId'
      },
      render: ({ value }) => value && value.externalDistributorName,
      defaultFlex: 1
    },
    {
      header: t('type'),
      name: 'distributionType',
      type: 'select',
      required: true,
      options: {
        data: [
          {
            distributionType: 'B2B'
          },
          {
            distributionType: 'B2C'
          }
        ],
        name: 'distributionType',
        uniqueId: 'distributionType',
        requestField: 'distributionType'
      },
      isEditable: true
    },
    {
      header: t('valid.from'),
      name: 'validFrom',
      type: 'date',
      isEditable: true,
      filterEditor: DateFilter,
      dateFormat: 'YYYY-MM-DDTHH:mm:ss'
    },
    {
      header: t('valid.to'),
      name: 'validTo',
      type: 'date',
      isEditable: true,
      filterEditor: DateFilter,
      dateFormat: 'YYYY-MM-DDTHH:mm:ss'
    },
    {
      header: t('is.active'),
      name: 'isActive',
      type: 'boolean',
      filterEditor: BoolFilter,
      isEditable: true,
      render: ({ value }) => <Switch disabled checked={value} />
    },
    {
      header: t('date.added'),
      name: 'dateAdded',
      type: 'date',
      filterEditor: DateFilter,
      dateFormat: 'YYYY-MM-DDTHH:mm:ss'
    }
  ];

  return (
    <>
      <Header title={t('promo.campaigns')} />
      <Toolbar iamResource={resource} />
      <Table
        iamResource={resource}
        uniqueId={'promoCampaignId'}
        tableId={'promoCampaign'}
        columns={columns}
        urls={urls}
      />
      <NavBar />
    </>
  );
};

export default PromoCampaign;
